import { ReactNode } from "react";
import "./pageHeader.scss";

export interface PageHeaderProps {
  /**
   * The page's title, rendered as the page's `<h1>`. Usually a plain translated string; widened
   * to `ReactNode` (Task 8, Materials detail) so a caller that needs a secondary bit of markup
   * inline with the title — the material's EAN next to its name, the one case so far — can pass
   * a fragment instead of collapsing it into one string. Every existing caller still passes a
   * plain string, which renders identically either way.
   */
  title: ReactNode;
  /**
   * Optional primary action, rendered at the header's trailing edge (e.g.
   * a "New user" `Button`). Left to the consumer so this primitive never
   * has to know what a given flow's primary action looks like.
   */
  action?: ReactNode;
}

/**
 * The heading bar every Carbon screen opens with: a title on the leading
 * edge, an optional primary action on the trailing edge.
 *
 * Owned by the primitives layer — Sites/Tags/Materials consume this
 * verbatim. If a flow needs a different header shape, this component
 * changes in place rather than being forked.
 */
const PageHeader = ({ title, action }: PageHeaderProps) => (
  <div className="page-header">
    <h1 className="page-header__title">{title}</h1>
    {action ? <div className="page-header__action">{action}</div> : null}
  </div>
);

export default PageHeader;
